<script setup>
// Ce qui est inclus pour tout l'office (VIG-450, B4.0).
// `app` : 8 lignes cochées, sur 2 colonnes remplies colonne par colonne (fenêtre de fin
// d'essai, Mon abonnement) ou sur une colonne (`columns="1"`, récapitulatif de Souscrire).
// `public` : 6 tuiles avec icône de la préinscription (B4.7).
defineProps({
  variant: {type: String, default: 'app', validator: (value) => ['app', 'public'].includes(value)},
  columns: {type: [Number, String], default: 2},
});

const APP_FEATURES = [
  'Dossiers et utilisateurs illimités',
  'Tous les criblages en une fois',
  'Rapport PDF horodaté pour l\'inspection',
  'Fiche de vigilance préremplie',
  'Surveillance continue',
  'Déclaration d\'origine des fonds',
  'Déclaration de bénéficiaire effectif',
  'Signature électronique',
];

const PUBLIC_FEATURES = [
  {icon: 'search', title: 'Toutes les vérifications', detail: ' : personnes physiques, personnes morales et biens immobiliers'},
  {icon: 'database', title: 'Toutes les bases de référence', detail: ', dont Dow Jones, gel des avoirs, PPE, BODACC, RBE et INPI'},
  {icon: 'document', title: 'Fiche de vigilance et rapport PDF horodaté', detail: ', prêts en cas de contrôle'},
  {icon: 'pen', title: 'DOF et DBE pré-remplies', detail: ', signées électroniquement par le client'},
  {icon: 'refresh', title: 'Contrôles et surveillance continue', detail: ', renouvellement automatique pendant 6 mois'},
  {icon: 'exchange', title: 'Import et export automatiques avec votre logiciel de rédaction d\'actes', detail: ''},
];
</script>

<template>
  <ul v-if="variant === 'app'"
      class="grid gap-x-7 gap-y-2.5 text-left"
      :class="Number(columns) === 1 ? 'grid-cols-1' : 'grid-cols-1 sm:grid-flow-col sm:grid-cols-2 sm:grid-rows-4'">
    <li v-for="feature in APP_FEATURES" :key="feature" class="flex items-start gap-2.5 text-sm font-medium leading-snug text-gray-800">
      <span class="mt-px flex h-5 w-5 flex-none items-center justify-center rounded-full bg-[#EAFDF9]" aria-hidden="true">
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#1EAC9C" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
      </span>
      <span>{{ feature }}</span>
    </li>
  </ul>

  <ul v-else class="grid gap-3.5 sm:grid-cols-2 sm:gap-4">
    <li v-for="feature in PUBLIC_FEATURES" :key="feature.title"
        class="flex min-h-16 items-center gap-3.5 rounded-2xl border border-gray-200 bg-white px-4 py-4">
      <span class="flex h-[42px] w-[42px] flex-none items-center justify-center rounded-xl bg-[#EAFDF9]" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1EAC9C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <template v-if="feature.icon === 'search'"><circle cx="11" cy="11" r="6.5"/><path d="M20 20l-4.2-4.2"/></template>
          <template v-else-if="feature.icon === 'database'"><ellipse cx="12" cy="6" rx="7" ry="2.8"/><path d="M5 6v12c0 1.5 3.1 2.8 7 2.8s7-1.3 7-2.8V6"/><path d="M5 12c0 1.5 3.1 2.8 7 2.8s7-1.3 7-2.8"/></template>
          <template v-else-if="feature.icon === 'document'"><path d="M7 3h7l4 4v14H7z"/><path d="M14 3v4h4"/><path d="M10 12h5M10 16h5"/></template>
          <template v-else-if="feature.icon === 'pen'"><path d="M4 20h4L19 9l-4-4L4 16z"/><path d="M13.5 6.5l4 4"/></template>
          <template v-else-if="feature.icon === 'refresh'"><path d="M20 12a8 8 0 1 1-2.3-5.6"/><path d="M20 4v4h-4"/></template>
          <template v-else><path d="M7 7h11l-3-3M17 17H6l3 3"/></template>
        </svg>
      </span>
      <p class="text-sm leading-snug text-gray-600"><b class="font-bold text-gray-800">{{ feature.title }}</b>{{ feature.detail }}</p>
    </li>
  </ul>
</template>
